/**
 * Store for information about the pending redirect, if any
 *
 * If multiple redirect changes are prepared, only the first will be registered in this store.
 *
 * @module
 */

var _ = require('optimizely-client-fn');

var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function() {
    this.__state = {
      layerId: null,
    };

    this.on(actionTypes.ANNOUNCE_PENDING_REDIRECT, this.__setRedirectInfo);
  },

  /**
   * @returns {boolean}
   */
  isExpectingRedirect: function(): boolean {
    return _.isString(this.__state.layerId);
  },

  /**
   * @returns {string|null} The ID of the first redirecting layer, if any.
   */
  getLayerId: function(): string|null {
    return this.__state.layerId;
  },

  /**
   * Record information about the first redirect change that is constructed on this page load.
   *
   * @param {Object} payload
   * @param {string} payload.layerId The ID of the redirecting layer.
   * @private
   */
  __setRedirectInfo: function(payload:any) {
    if (this.isExpectingRedirect()) {
      return;
    }

    this.__state.layerId = payload.layerId;
    this.emitChange();
  },
};
